var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Review ")]),
      _c(
        "gg-card-text",
        [
          _c(
            "v-row",
            {
              staticClass: "pt-2"
            },
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "mb-0"
                    },
                    [
                      _c("b", [_vm._v("Website Type: ")]),
                      _vm._v(" " + _vm._s(_vm.starterSite.website_type) + " ")
                    ]
                  )
                ]
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "mb-0"
                    },
                    [
                      _c("b", [_vm._v("Website Name: ")]),
                      _vm._v(" " + _vm._s(_vm.starterSite.website_name) + " ")
                    ]
                  )
                ]
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "mb-0"
                    },
                    [
                      _c("b", [_vm._v("About Website: ")]),
                      _c("span", {
                        directives: [
                          {
                            name: "no-data",
                            rawName: "v-no-data",
                            value: _vm.starterSite.contentAbout,
                            expression: "starterSite.contentAbout"
                          }
                        ]
                      })
                    ]
                  )
                ]
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "mb-0"
                    },
                    [
                      _c("b", [_vm._v("Website Purpose: ")]),
                      _c("span", {
                        directives: [
                          {
                            name: "no-data",
                            rawName: "v-no-data",
                            value: _vm.starterSite.website_description,
                            expression: "starterSite.website_description"
                          }
                        ]
                      })
                    ]
                  )
                ]
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "mb-2"
                    },
                    [
                      _c("b", [_vm._v("Products & Services: ")]),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.starterSite.contentServices.filter(
                                function(cs) {
                                  return !!cs
                                }
                              ).length,
                              expression:
                                "!starterSite.contentServices.filter(cs => !!cs).length"
                            }
                          ],
                          staticClass: "mb-0 grey--text text--darken-3"
                        },
                        [_vm._v(" Not Specified ")]
                      )
                    ]
                  ),
                  _vm._l(_vm.starterSite.contentServices, function(
                    service,
                    index
                  ) {
                    return _c("p", {
                      key: "r-ps".concat(index),
                      staticClass: "mb-2",
                      domProps: {
                        innerHTML: _vm._s(service)
                      }
                    })
                  })
                ],
                2
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "mb-0"
                    },
                    [
                      _c("b", [_vm._v("Email Address: ")]),
                      _c("span", {
                        directives: [
                          {
                            name: "no-data",
                            rawName: "v-no-data",
                            value: _vm.starterSite.companyEmail,
                            expression: "starterSite.companyEmail"
                          }
                        ]
                      })
                    ]
                  )
                ]
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "mb-0"
                    },
                    [
                      _c("b", [_vm._v("Phone Number: ")]),
                      _c("span", {
                        directives: [
                          {
                            name: "no-data",
                            rawName: "v-no-data",
                            value: _vm.starterSite.companyPhone,
                            expression: "starterSite.companyPhone"
                          }
                        ]
                      })
                    ]
                  )
                ]
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "mb-0"
                    },
                    [
                      _c("b", [_vm._v("Facebook Link: ")]),
                      _c("span", {
                        directives: [
                          {
                            name: "no-data",
                            rawName: "v-no-data",
                            value: _vm.starterSite.socialFacebook,
                            expression: "starterSite.socialFacebook"
                          }
                        ]
                      })
                    ]
                  )
                ]
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "mb-0"
                    },
                    [
                      _c("b", [_vm._v("Twitter Link: ")]),
                      _c("span", {
                        directives: [
                          {
                            name: "no-data",
                            rawName: "v-no-data",
                            value: _vm.starterSite.socialTwitter,
                            expression: "starterSite.socialTwitter"
                          }
                        ]
                      })
                    ]
                  )
                ]
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "mb-0"
                    },
                    [
                      _c("b", [_vm._v("Instagram Link: ")]),
                      _c("span", {
                        directives: [
                          {
                            name: "no-data",
                            rawName: "v-no-data",
                            value: _vm.starterSite.socialInstagram,
                            expression: "starterSite.socialInstagram"
                          }
                        ]
                      })
                    ]
                  )
                ]
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "mb-0"
                    },
                    [
                      _c("b", [_vm._v("Pinterest Link: ")]),
                      _c("span", {
                        directives: [
                          {
                            name: "no-data",
                            rawName: "v-no-data",
                            value: _vm.starterSite.socialPintrest,
                            expression: "starterSite.socialPintrest"
                          }
                        ]
                      })
                    ]
                  )
                ]
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "mb-0"
                    },
                    [
                      _c("b", [_vm._v("LinkedIn Link: ")]),
                      _c("span", {
                        directives: [
                          {
                            name: "no-data",
                            rawName: "v-no-data",
                            value: _vm.starterSite.socialLinkedIn,
                            expression: "starterSite.socialLinkedIn"
                          }
                        ]
                      })
                    ]
                  )
                ]
              ),
              _vm.starterSite.businessHours
                ? _c(
                    "v-col",
                    {
                      staticClass: "mt-2",
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c(
                        "p",
                        {
                          staticClass: "font-weight-bold mb-0"
                        },
                        [_vm._v("Business Hours:")]
                      ),
                      _vm._l(_vm.days, function(day, i) {
                        return _c(
                          "p",
                          {
                            key: "r-d".concat(i),
                            staticClass: "mt-4 mb-0"
                          },
                          [
                            _c("b", [_vm._v(_vm._s(day))]),
                            _vm._v(" Open At: "),
                            _c("span", {
                              directives: [
                                {
                                  name: "no-data",
                                  rawName: "v-no-data",
                                  value: _vm.starterSite["hoursOpen" + day],
                                  expression: "starterSite['hoursOpen' + day]"
                                }
                              ]
                            }),
                            _vm._v(" Close At: "),
                            _c("span", {
                              directives: [
                                {
                                  name: "no-data",
                                  rawName: "v-no-data",
                                  value: _vm.starterSite["hoursClosed" + day],
                                  expression: "starterSite['hoursClosed' + day]"
                                }
                              ]
                            })
                          ]
                        )
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm.starterSite.physicalAddress
                ? [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12",
                          md: "6"
                        }
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "mb-0"
                          },
                          [
                            _c("b", [_vm._v("Address:")]),
                            _vm._v(" "),
                            _c("span", {
                              directives: [
                                {
                                  name: "no-data",
                                  rawName: "v-no-data",
                                  value: _vm.starterSite.contactAddress,
                                  expression: "starterSite.contactAddress"
                                }
                              ]
                            })
                          ]
                        )
                      ]
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12",
                          md: "6"
                        }
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "mb-0"
                          },
                          [
                            _c("b", [_vm._v("Country:")]),
                            _vm._v(" "),
                            _c("span", {
                              directives: [
                                {
                                  name: "no-data",
                                  rawName: "v-no-data",
                                  value: _vm.starterSite.contactCountry,
                                  expression: "starterSite.contactCountry"
                                }
                              ]
                            })
                          ]
                        )
                      ]
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12",
                          md: "6"
                        }
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "mb-0"
                          },
                          [
                            _c("b", [_vm._v("State:")]),
                            _vm._v(" "),
                            _c("span", {
                              directives: [
                                {
                                  name: "no-data",
                                  rawName: "v-no-data",
                                  value: _vm.starterSite.contactState,
                                  expression: "starterSite.contactState"
                                }
                              ]
                            })
                          ]
                        )
                      ]
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12",
                          md: "6"
                        }
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "mb-0"
                          },
                          [
                            _c("b", [_vm._v("City:")]),
                            _vm._v(" "),
                            _c("span", {
                              directives: [
                                {
                                  name: "no-data",
                                  rawName: "v-no-data",
                                  value: _vm.starterSite.contactCity,
                                  expression: "starterSite.contactCity"
                                }
                              ]
                            })
                          ]
                        )
                      ]
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12",
                          md: "6"
                        }
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "mb-0"
                          },
                          [
                            _c("b", [_vm._v("Postcode:")]),
                            _vm._v(" "),
                            _c("span", {
                              directives: [
                                {
                                  name: "no-data",
                                  rawName: "v-no-data",
                                  value: _vm.starterSite.contactPostcode,
                                  expression: "starterSite.contactPostcode"
                                }
                              ]
                            })
                          ]
                        )
                      ]
                    )
                  ]
                : _vm._e(),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "font-weight-bold"
                    },
                    [_vm._v("Website Layout:")]
                  ),
                  _c("v-img", {
                    attrs: {
                      src: _vm.themeImage(_vm.theme),
                      position: "top",
                      height: "860",
                      "max-height": "860",
                      "max-width": "250"
                    }
                  })
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }